"use strict";

import { onboardingConstants } from "../_constants";

const INITIAL_ONBOARDING_STATE = {
  ownFormData: {},
  locationKey: null,
  nicPassvalidateData: {},
  debitCardPreRequestData: {},
  PostRequestData: {},
  otpConfirmationData: {},
  userNameValidateData: {},
  verificationData: {},
  addProfileData: {},
  onBoardingOtpTimer: 0,
  currentStep: onboardingConstants.NIC_PASSPORT_VALIDATION_STEP,
};

export function onboarding(state = INITIAL_ONBOARDING_STATE, action) {
  switch (action.type) {
    case onboardingConstants.NIC_VALIDATE_REQUEST:
      return {
        ...state,
        ownFormData: action.payload?.restoreData,
        nicPassvalidateData: {},
      };

    case onboardingConstants.NIC_VALIDATE_COMPLETE:
      return {
        ...state,
        nicPassvalidateData: action.payload?.data,
        onBoardingOtpTimer: action?.payload?.data?.otpTimerTimePeriod,
      };

    case onboardingConstants.NIC_VALIDATE_ERROR:
      return {
        ...state,
        nicPassvalidateData: action?.payload?.response?.errorDetails,
        onBoardingOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime,
      };

    case onboardingConstants.ONBOARDING_CLEAR_FORM_DATA:
      return {
        ...state,
        ownFormData: {},
        nicPassvalidateData: {},
      };

    case onboardingConstants.ONBOARDING_TRY_AGAIN_FLOW:
      return {
        ...state,
        ownFormData: {
          nicNumber: state.ownFormData.nicNumber,
          passportNumber: state.ownFormData.passportNumber,
          selectedTab: state.ownFormData.selectedTab,
        },
        nicPassvalidateData: {},
      };

    case onboardingConstants.ONBOARDING_CLEAR_FORM_RESPONSE_DATA:
      return {
        ...state,
        nicPassvalidateData: {},
        debitCardPreRequestData: {},
        PostRequestData: {},
        onBoardingOtpTimer: 0,
        otpConfirmationData: {},
        userNameValidateData: {},
        verificationData: {},
        addProfileData: {},
      };

    case onboardingConstants.ASSIGN_REGISTRATION_TYPE:
      return {
        ...state,
        debitCardPreRequestData: {},
        PostRequestData: {},
        onBoardingOtpTimer: 0,
        otpConfirmationData: {},
        userNameValidateData: {},
        ownFormData: {
          ...state.ownFormData,
          registrationType: action.payload?.registrationType,
          accountType: action.payload?.accountType,
        },
      };

    case onboardingConstants.ALTERNATIVE_FLOW_ASSIGN_REGISTRATION_TYPE:
      return {
        ...state,
        ownFormData: {
          ...state.ownFormData,
          registrationType: action?.payload?.registrationType,
          alternativeFLowActive: action?.payload?.alternativeFLowActive,
        },
      };

    case onboardingConstants.ASSIGN_VERIFICATION_TYPE:
      return {
        ...state,
        ownFormData: {
          ...state.ownFormData,
          verifcationType: action.payload?.verifcationType,
        },
      };

    case onboardingConstants.DEBIT_CARD_PRE_REGISTER_REQUEST:
      // Do not store PIN/PAN/card secrets in Redux (XSS / sessionStorage risk).
      // Keep only non-sensitive restore fields used for wizard UX.
      return {
        ...state,
        ownFormData: {
          ...state.ownFormData,
          cardNo: action.payload?.restoreData?.cardNo,
          pin: action.payload?.restoreData?.pin,
          accountNumber: action?.payload?.restoreData?.accountNumber,
          cardNumber: action.payload?.restoreData?.cardNumber,
          canNumber: action.payload?.restoreData?.canNumber,
          expDate: action.payload?.restoreData?.expDate,
          cardType: action?.payload?.restoreData?.cardType,
        },
      };

    case onboardingConstants.DEBIT_CARD_PRE_REGISTER_COMPLETE:
      return {
        ...state,
        debitCardPreRequestData: action?.payload?.data,
      };

    case onboardingConstants.DEBIT_CARD_PRE_REGISTER_ERROR:
      return {
        ...state,
        debitCardPreRequestData: {},
      };

    case onboardingConstants.DEBIT_CARD_INIT_REGISTER_REQUEST:
      return {
        ...state,
        PostRequestData: {},
        onBoardingOtpTimer: 0,
      };

    case onboardingConstants.DEBIT_CARD_INIT_REGISTER_COMPLETE:
      return {
        ...state,
        PostRequestData: action?.payload?.data,
        onBoardingOtpTimer: action?.payload?.data?.otpTimerTimePeriod,
      };

    case onboardingConstants.DEBIT_CARD_INIT_REGISTER_ERROR:
      return {
        ...state,
        PostRequestData: action?.payload?.response?.errorDetails,
        onBoardingOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime,
      };

    case onboardingConstants.ONBOARDING_OTP_CONFIRM_COMPLETE:
      return {
        ...state,
        otpConfirmationData: action.payload.data,
        onBoardingOtpTimer: 0,
      };

    case onboardingConstants.ONBOARDING_OTP_CONFIRM_ERROR:
      return {
        ...state,
        otpConfirmationData: {},
      };

    case onboardingConstants.USERNAME_VALIDATE_COMPLETE:
      return {
        ...state,
        userNameValidateData: action?.payload?.data,
      };

    case onboardingConstants.USERNAME_VALIDATE_ERROR:
      return {
        ...state,
        userNameValidateData: action?.payload?.response?.errorResponse,
      };

    case onboardingConstants.BACKOFFICE_VALIDATION_COMPLETE:
      return {
        ...state,
        verificationData: action?.payload?.data?.customer,
      };

    case onboardingConstants.BACKOFFICE_VALIDATION_ERROR:
      return {
        ...state,
        verificationData: {},
      };

    case onboardingConstants.ADD_PROFILE_INFO_REQUEST:
      return {
        ...state,
        addProfileData: action?.payload?.data,
      };

    case onboardingConstants.ADD_PROFILE_INFO_COMPLETE:
      return {
        ...state,
        addProfileData: action?.payload?.data,
      };

    case onboardingConstants.STORE_PROFILE_WIZARD_DETAILS:
      // Never store password in Redux; username/nickname only.
      return {
        ...state,
        ownFormData: {
          ...state.ownFormData,
          username: action.payload?.username || state.ownFormData?.username,
          nickname: action.payload?.nickname || state.ownFormData?.nickname,
        },
      };

    case onboardingConstants.CLEAR_VALIDATE_USERNAME_DATA:
      return {
        ...state,
        userNameValidateData: {},
      };

    case onboardingConstants.STORE_CURRENT_STEP:
      return {
        ...state,
        currentStep: action?.payload.stepName,
      };

    case onboardingConstants.REMOVE_OWN_FORM_DATA_FIELDS:
      const updatedFormData = { ...state.ownFormData };
      (action.payload || []).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(updatedFormData, key)) {
          updatedFormData[key] = "";
        }
      });

      return {
        ...state,
        ownFormData: updatedFormData,
      };

    default:
      return state;
  }
}
